import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Badge from "../components/Badge";
import "./MemberStatusCard.css";
function MemberStatusCard(props) {
    return (_jsxs("div", { children: [_jsx("p", { children: props.name }, void 0), _jsx(Badge, { title: props.status, text_color: "text-white", bg_color: "bg-green" }, void 0)] }, void 0));
}
export default MemberStatusCard;



//////////////////
// WEBPACK FOOTER
// ./src/components/MemberStatusCard.tsx
// module id = 66
// module chunks = 0